import Vue from 'vue';
import App from './App.vue';
import store from './store/store';
import './assets/app.scss';
import Flicking from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";

Vue.use(Flicking);

Vue.filter('intToDecimalPrice', int => '$' + (int / 100).toFixed(2));

Vue.filter('moneySaleFormat', (price) => {
  if (price) {
    return `$${price}`;
  }
  return '';
});

Vue.filter('moneyFormat', (product) => {
  if (product.variants) {
    return `$${product.variants[0].price}`;
  }
  return '';
});

Vue.filter('moneyFloatFormat', (product) => {
  if (product.variants) {
    return `$${parseFloat(product.variants[0].price)}`;
  }
  return '';
});

Vue.filter('getProductImage', product => (product.images.length > 0) ? product.images[0].src : '');

Vue.filter('getProductDesc', product => {
  return product.body_html.replace(/<script>[\s\S]*<\/script>/g,'').replace( /(<([^>]+)>)/ig, '');
});

Array.prototype.swapItems = function(a, b){
  this[a] = this.splice(b, 1, this[a])[0];
  return this;
}


/* eslint-disable no-unused-vars */
const CuratedListingApp = new Vue({
  el: '#CollectionGifting',
  data: {
  },
  store,
  created() {
    this.$store.dispatch('getProducts');
  },
  render: h => h(App),
});
